import request from '@/utils/request'

const getAchievementById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-achievement/${id}`,
    method: 'get'
  })
}

const getAchievementByPlanId = (planId) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-achievement/by-plan-id/${planId}`,
    method: 'get'
  })
}

const getAchievementPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-achievement/page-list`,
    method: 'get',
    params: query
  })
}

function createAchievement(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-achievement`,
    method: 'post',
    data
  })
}


export default {
  createAchievement,
  getAchievementById,
  getAchievementByPlanId,
  getAchievementPageList
}
